enum EFeature {
    Users = "users",
    Roles = "roles",
    Transactions = "transactions",
    Messages = "messages",
    Messenger = "messenger",
    Template = "template"
}

export default EFeature